import * as React from 'react';
import bind from 'bind-decorator';
import { Button, Dropdown } from 'react-bootstrap';
import { FormInterface } from '../../Interfaces/Forms/FormsInterface';
import { SingleInstance } from '../../Interfaces/ModuleSelectionInterface';
import { getLocalization } from '../../global/global';

interface Props {
  forms: FormInterface[];
  setSingleInstance: (singleInstance: SingleInstance) => void;
}

export default class AddPoiComponent extends React.Component<Props> {

  constructor(props) {
    super(props);
  }

  @bind
  private onClick(form: FormInterface) {
    const singleInstance: SingleInstance = {
      newAnswer: true,
      model: form,
      dataPoint: { formId: form.id, questionnaire_id: form.ref }
    };
    this.props.setSingleInstance(singleInstance);
  }

  public render() {
    const { forms } = this.props;
    if (forms.length === 1) {
      return (
        <Button
          size={'sm'}
          onClick={() => this.onClick(forms[0])}
          id={'add-poi-dropdown-btn'}
        >
          <i className="fa fa-map-marker" />
          {` ${getLocalization('adddatapoint')}`}
        </Button>
      );
    }
    return (
      <Dropdown
        id={'add-poi-dropdown-btn'}
      >
        <Dropdown.Toggle size={'sm'} id="add-poi-dropdown-toggle">
          <i className="fa fa-map-marker" />
          {` ${getLocalization('adddatapoint')}`}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {forms.map((form) => {
            return !form.isChild && (
              <Dropdown.Item
                key={form.ref}
                eventKey="1"
                onClick={() => this.onClick(form)}
                id={`add-poi-${form.ref}-btn`}
              >
                {form.name}
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}
